import { AppBox, AppContainer, AppPaginator } from "../../../commons/components";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../hooks/app";
import { Outlet, useParams } from "react-router";
import OrganizerList from "./components/OrganizerList";
import { setPageTitle } from "../../../redux/slices/page-title-slice";

import usePagination from "../../../hooks/usePagination";
import useFilter from "../../../hooks/useFilter";
import {
  cleanUpFootballOrganizerList,
  fetchManageFootballOrganizerList,
} from "../../../redux/slices/football/admin/organizer/manage-football-organizer-list-slice";

export default function OrganizerManage() {
  const dispatch = useAppDispatch();
  const { stadiumId } = useParams();
  const { footballOrganizerList } = useAppSelector((state) => state.manageFootballOrganizerList);
  const { page, perPage, pageChange, pageLimitChange } = usePagination();
  const { searchText, sortOrder, sortBy } = useFilter();

  useEffect(() => {
    dispatch(setPageTitle("Organizers"));
  }, []);

  useEffect(() => {
    dispatch(fetchManageFootballOrganizerList({ sort: sortBy, sortOrder, name: searchText, page, perPage }));
  }, [page, perPage, searchText, sortBy, sortOrder]);

  useEffect(() => {
    return () => {
      dispatch(cleanUpFootballOrganizerList());
    };
  }, []);

  return (
    <>
      {stadiumId ? (
        <Outlet />
      ) : (
        <AppContainer>
          <AppBox py="md" flexDirection="column" gap="md">
            <OrganizerList />
            {footballOrganizerList?.pageCount > 1 && (
              <AppPaginator
                perPage={footballOrganizerList.perPage}
                pageCount={footballOrganizerList.pageCount}
                currentPage={footballOrganizerList.page}
                pageChange={pageChange}
                perPageLimitChange={pageLimitChange}
              />
            )}
          </AppBox>
        </AppContainer>
      )}
    </>
  );
}
